var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSidebarMenu = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 1.5C2.05964 1.5 1.5 2.05964 1.5 2.75V21.25C1.5 21.9404 2.05964 22.5 2.75 22.5H21.25C21.9404 22.5 22.5 21.9404 22.5 21.25V2.75C22.5 2.05964 21.9404 1.5 21.25 1.5H2.75ZM0 2.75C0 1.23122 1.23122 0 2.75 0H21.25C22.7688 0 24 1.23122 24 2.75V21.25C24 22.7688 22.7688 24 21.25 24H2.75C1.23122 24 0 22.7688 0 21.25V2.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 0C8.66421 0 9 0.335786 9 0.75V23.25C9 23.6642 8.66421 24 8.25 24C7.83579 24 7.5 23.6642 7.5 23.25V0.75C7.5 0.335786 7.83579 0 8.25 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.5C3 3.67157 3.67157 3 4.5 3C5.32843 3 6 3.67157 6 4.5V19.5C6 20.3284 5.32843 21 4.5 21C3.67157 21 3 20.3284 3 19.5V4.5Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSidebarMenu);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sidebar-menu.a72d907a9a246da25a6f81089e5cbc63.svg";